import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type UpdateContainerCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateContainerCargoItemInput;
}>;

export type UpdateContainerCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoUpdateContainerCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateContainerCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<
            GraphQLTypes.CargoContainerType,
            | 'containerNumber'
            | 'containerSealNumber'
            | 'containerType'
            | 'dryStandard'
            | 'flatRack'
            | 'garmentsOnHangers'
            | 'openTop'
            | 'overweight'
            | 'cbm'
            | 'hazardous'
            | 'id'
            | 'looseCargoType'
            | 'quantity'
            | 'reefer'
            | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<
            GraphQLTypes.CargoLooseCargoType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoVehicleType' } & Pick<
            GraphQLTypes.CargoVehicleType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateContainerCargoItemDocument = gql`
  mutation updateContainerCargoItem($input: UpdateContainerCargoItemInput!) {
    cargoUpdateContainerCargoItem(input: $input) {
      cargoItem {
        cbm
        grossWeight {
          metric
          value
        }
        hazardous
        id
        looseCargoType
        quantity
        reefer
        type
        ... on CargoContainerType {
          containerNumber
          containerSealNumber
          containerType
          dryStandard
          flatRack
          garmentsOnHangers
          openTop
          overweight
        }
      }
      errors {
        message
        path
      }
    }
  }
`;
